<template>
  <div id="access" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>アクセス</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">会社案内</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="company-layout">
        <CompanyNav active-key="access" />

        <div class="page-card">
          <p class="page-kicker">Access</p>
          <h2>事務所情報</h2>
          <div class="info-grid">
            <article class="info-panel">
              <h3>住所</h3>
              <p>〒850-0035 長崎県長崎市元船町9-18 2階</p>
            </article>
            <article class="info-panel">
              <h3>電車</h3>
              <p>長崎電軌本線 五島町駅 徒歩3分</p>
              <p>長崎電軌本線 大波止駅 徒歩4分</p>
              <p>西九州新幹線 長崎駅 徒歩10分</p>
            </article>
            <article class="info-panel">
              <h3>Email</h3>
              <p>info@innosource.co.jp</p>
            </article>
            <article class="info-panel">
              <h3>受付時間</h3>
              <p>平日10:00～12:00 13:00～17:30</p>
              <p>土日、祝祭日、年末年始、弊社が定める定休日を除く</p>
            </article>
          </div>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';
import CompanyNav from '@/components/companyNav';

export default {
  name: 'access',
  components: {
    Top,
    Foot,
    CompanyNav,
  },
};
</script>
